import * as React from 'react';
import { SVGProps } from 'react';

const WarningIconAuth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="45"
    height="39"
    viewBox="0 0 45 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.3036 1.25007L44.1494 35.6251C44.3323 35.9418 44.4285 36.301 44.4285 36.6667C44.4285 37.0324 44.3323 37.3917 44.1494 37.7084C43.9666 38.0251 43.7036 38.2881 43.3869 38.4709C43.0702 38.6538 42.711 38.7501 42.3453 38.7501H2.65359C2.2879 38.7501 1.92864 38.6538 1.61194 38.4709C1.29525 38.2881 1.03226 38.0251 0.849413 37.7084C0.666569 37.3917 0.57031 37.0324 0.570313 36.6667C0.570315 36.301 0.666578 35.9418 0.849426 35.6251L20.6953 1.25007C20.8781 0.933389 21.1411 0.670417 21.4578 0.487583C21.7745 0.304749 22.1337 0.208496 22.4994 0.208496C22.8651 0.208496 23.2243 0.304749 23.541 0.487583C23.8577 0.670417 24.1207 0.933389 24.3036 1.25007ZM6.26193 34.5834H38.7369L22.4994 6.4584L6.26193 34.5834ZM20.4161 28.3334H24.5828V32.5001H20.4161V28.3334ZM20.4161 13.7501H24.5828V24.1667H20.4161V13.7501Z"
      fill="#F58021"
    />
  </svg>
);

export default WarningIconAuth;
